import script from "./DataTableColumnSelectionItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataTableColumnSelectionItem.vue?vue&type=script&setup=true&lang=ts"

import "./DataTableColumnSelectionItem.vue?vue&type=style&index=0&id=da7c3964&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-da7c3964"]])

export default __exports__